import { createRoot } from 'react-dom/client';

import AppWithProviders from './AppWithProviders';
// Standalone dev entry — safe to import CSS here (this file is never used by federation).
import './app.css';

createRoot(document.getElementById('root')!).render(<AppWithProviders />);
